import { baseApi, PaginatedResponse } from 'sama-shared';
import type { GetSubscriptionsParams } from '../../types/api';
import type {
  AdminSubscription,
  AdminSubscriptionWithDetails,
  AssignPlanRequest,
  AssignPlanResponse,
} from './types/subscription';

export const subscriptionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubscription: builder.query<PaginatedResponse<AdminSubscription>, GetSubscriptionsParams>({
      query: (params) => ({
        url: '/admin/subscription',
        method: 'GET',
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'Subscription' as const, id })),
              { type: 'Subscription', id: 'LIST' },
            ]
          : [{ type: 'Subscription', id: 'LIST' }],
    }),

    getSubscriptionDetails: builder.query<AdminSubscriptionWithDetails, string>({
      query: (id) => ({
        url: `/admin/subscription/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'Subscription', id }],
    }),

    assignPlanToPartner: builder.mutation<AssignPlanResponse, AssignPlanRequest>({
      query: ({ partnerId, planId }) => ({
        url: `/admin/subscription/assign-plan`,
        method: 'POST',
        body: { partnerId, planId },
      }),
      invalidatesTags: (result) => [
        { type: 'Subscription', id: 'LIST' },
        ...(result?.subscription?.id
          ? [{ type: 'Subscription' as const, id: result.subscription.id }]
          : []),
        { type: 'Partner', id: 'LIST' },
      ],
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetSubscriptionQuery,
  useGetSubscriptionDetailsQuery,
  useLazyGetSubscriptionDetailsQuery,
  useAssignPlanToPartnerMutation,
} = subscriptionApi;
